import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, onSnapshot, query, orderBy, serverTimestamp } from 'firebase/firestore';

const postsCollection = collection(db, 'posts');

const FirestoreDemo = () => {
  const [posts, setPosts] = useState([]);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const q = query(postsCollection, orderBy('created', 'desc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setPosts(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }, err => setError(err.message));
    return () => unsubscribe();
  }, []);

  const handleAddPost = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await addDoc(postsCollection, {
        text,
        created: serverTimestamp()
      });
      setText('');
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 500, margin: '40px auto', padding: 24, border: '1px solid #eee', borderRadius: 8 }}>
      <h2>Firestore Demo: Posts</h2>
      <form onSubmit={handleAddPost} style={{ marginBottom: 24 }}>
        <input
          type="text"
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder="Write something..."
          required
          style={{ width: '70%', padding: 8, marginRight: 8 }}
        />
        <button type="submit" disabled={loading || !text.trim()}>Add Post</button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {posts.map(post => (
          <li key={post.id} style={{ padding: 12, borderBottom: '1px solid #eee' }}>
            {post.text || <em>(No text)</em>}
            <div style={{ fontSize: 12, color: '#888' }}>
              {post.created?.toDate ? post.created.toDate().toLocaleString() : 'Just now'}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FirestoreDemo;
